import { T } from '@territory/tokens';

/* Shipped Resource tier, scope and plan choices. The caller owns selection. */
export function marketingResourceChoiceCss(sel: string): string {
  return `${sel} { padding: 8px 14px; border-radius: 999px; cursor: pointer; border: 1px solid var(--rv-border, ${T.separator}); background: transparent; color: var(--rv-text-sec, ${T.labelSec}); font-family: ${T.mono}; font-size: 0.62rem; letter-spacing: 0.1em; text-transform: uppercase; }
${sel}:focus-visible { outline-offset: 3px; }
${sel}[data-rv-selected="true"] { border-color: ${T.accent}; background: color-mix(in srgb, ${T.accent} 9.41%, transparent); color: ${T.accent}; }
${sel}[data-rv-resource-choice-layout="scope"] { padding: 7px 14px; font-size: 0.6rem; }
${sel}[data-rv-resource-choice-layout="plan"] { padding: 8px 13px; border-radius: 10px; font-size: 0.6rem; letter-spacing: 0.08em; }`;
}
